(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Existing hash-scroll function */
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  /*
   * RDCC CUSTOM SORT
   * Default = Price, low to high
   */
  document.addEventListener('DOMContentLoaded', () => {

    const currentUrl = new URL(window.location.href);

    if (!currentUrl.searchParams.has('sort_by')) {
      currentUrl.searchParams.set('sort_by', 'price-ascending');
      window.location.replace(currentUrl.toString());
      return;
    }


    function movePriceLowToHighFirst() {

      const sortSelects = document.querySelectorAll(
        'select[name="sort_by"], select[id*="sort"], select[data-sort-by]'
      );

      sortSelects.forEach((select) => {

        const priceOption = Array.from(select.options).find(
          (option) => option.value === 'price-ascending'
        );

        if (priceOption && select.options[0] !== priceOption) {
          select.insertBefore(priceOption, select.options[0]);
        }

        if (
          new URL(window.location.href).searchParams.get('sort_by') ===
          'price-ascending'
        ) {
          select.value = 'price-ascending';
        }

      });


      const priceSortItems = document.querySelectorAll(
        '[data-value="price-ascending"], [value="price-ascending"]'
      );

      priceSortItems.forEach((item) => {

        const menuItem = item.closest('li');

        if (!menuItem) return;

        const menu = menuItem.parentElement;

        if (!menu) return;

        if (menu.firstElementChild !== menuItem) {
          menu.insertBefore(menuItem, menu.firstElementChild);
        }

      });

    }


    movePriceLowToHighFirst();


    const observer = new MutationObserver(() => {
      movePriceLowToHighFirst();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  });

  } catch(e) { console.error(e); }
})();
})();
